import type { AxiosResponse } from "axios";

import api from "../utils/AxiosInterceptor";

export interface DataUser {
  id: number;
  name: string;
  email: string;
  phone: string;
  cellphone: string;
  cep: string;
  street: string;
  city: string;
  state: string;
  neighborhood: string;
  streetNumber: string;
  complement?: string;
  document: string;
  documentType: string;
  birthDate?: string;
  deleted: boolean;
  verified: boolean;
  active: boolean;
  termAccepted: boolean;
}

export async function getUser(userId: number): Promise<DataUser> {
  const response: AxiosResponse<DataUser> = await api.get(
    `/api/v1/users/${userId}`,
  );
  return response.data;
}
